import {combineReducers} from 'redux';
import Common from './common';

/**
 * @author wangwei
 * 合并reducer
 */

const rootReducer = combineReducers({
    Common,
})

export default rootReducer
